import Axios from "axios";
import { SET_INV_ISSUE_REPORT, UNSET_INV_ISSUE_REPORT } from "@/store/mutation-types";
import { getInvIssueReport } from "@/store/api";

const state = { getInvIssueReport: {} };

const getters = {
  getInvIssueReport(state) {
    return state.getInvIssueReport;
  },
};

const mutations = {
  [SET_INV_ISSUE_REPORT](state, data) {
    state.getInvIssueReport = data;
  },
  [UNSET_INV_ISSUE_REPORT](state) {
    state.getInvIssueReport = {};
  },
};

const actions = {
  getInvIssueReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvIssueReport, { params: data })
        .then(function (response) {
          commit("SET_INV_ISSUE_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_ISSUE_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
